import {
  LayoutDashboard,
  Building2,
  Handshake,
  MapPin,
  Package,
  Truck,
  Users,
  CalendarClock,
  UserCog,
  ClipboardList,
  Route,
  Euro,
  Receipt,
  Settings2,
} from "lucide-react";

export const NAV_GROUPS = [
  {
    label: null,
    items: [{ to: "/", label: "Dashboard", icon: LayoutDashboard, testid: "nav-dashboard" }],
  },
  {
    label: "Anagrafiche",
    items: [
      { to: "/clienti", label: "Clienti", icon: Building2, entity: "clienti", testid: "nav-clienti" },
      { to: "/subvettori", label: "Sub-vettori", icon: Handshake, entity: "subvettori", testid: "nav-subvettori" },
      { to: "/localita", label: "Località", icon: MapPin, entity: "localita", testid: "nav-localita" },
      { to: "/prodotti", label: "Prodotti", icon: Package, entity: "prodotti", testid: "nav-prodotti" },
    ],
  },
  {
    label: "Operatività",
    items: [
      { to: "/viaggi", label: "Viaggi", icon: Route, testid: "nav-viaggi" },
    ],
  },
  {
    label: "Amministrazione",
    items: [
      { to: "/listini", label: "Listini tariffe", icon: Euro, testid: "nav-listini" },
      { to: "/prefatture", label: "Prefatture", icon: Receipt, testid: "nav-prefatture" },
      { to: "/azienda", label: "Impostazioni", icon: Settings2, adminOnly: true, testid: "nav-azienda" },
    ],
  },
  {
    label: "Flotta",
    items: [
      { to: "/veicoli", label: "Veicoli", icon: Truck, entity: "veicoli", testid: "nav-veicoli" },
      { to: "/scadenzario/mezzi", label: "Scadenzario mezzi", icon: CalendarClock, testid: "nav-scad-mezzi" },
    ],
  },
  {
    label: "Personale",
    items: [
      { to: "/autisti", label: "Autisti", icon: Users, entity: "autisti", testid: "nav-autisti" },
      { to: "/scadenzario/autisti", label: "Scadenzario autisti", icon: CalendarClock, testid: "nav-scad-autisti" },
    ],
  },
  {
    label: "Sistema",
    items: [
      { to: "/utenti", label: "Utenti", icon: UserCog, adminOnly: true, testid: "nav-utenti" },
      { to: "/audit", label: "Log attività", icon: ClipboardList, adminOnly: true, testid: "nav-audit" },
    ],
  },
];

export const PAGE_TITLES = {
  "/": "Dashboard",
  "/viaggi": "Viaggi",
  "/listini": "Listini tariffe",
  "/prefatture": "Prefatture",
  "/azienda": "Impostazioni",
  "/clienti": "Clienti",
  "/subvettori": "Sub-vettori",
  "/localita": "Località",
  "/prodotti": "Prodotti",
  "/veicoli": "Veicoli",
  "/scadenzario/mezzi": "Scadenzario mezzi",
  "/autisti": "Autisti",
  "/scadenzario/autisti": "Scadenzario autisti",
  "/utenti": "Utenti",
  "/audit": "Log attività",
};
